module.exports = __webpack_public_path__ + "static/media/renoveru.80e6971d.svg";